import { createApp } from 'vue'
import { createPinia } from 'pinia'

import AmplifyVue from '@aws-amplify/ui-vue';
import App from './App.vue';
import Aura from '@primevue/themes/aura';
import ConfirmationService from 'primevue/confirmationservice';
import PrimeVue from 'primevue/config';
import router from './router';
import Ripple from 'primevue/ripple';
import ToastService from 'primevue/toastservice';
import Tooltip from "primevue/tooltip";
import 'primeicons/primeicons.css';

import '@aws-amplify/ui-vue/styles.css';
import 'animate.css';
import './style.css';

import * as Sentry from "@sentry/vue";

const ENV_NAME: string = import.meta.env.VITE_ENVIRONMENT;
const SENTRY_DSN: string = import.meta.env.VITE_SENTRY_DSN;

const app = createApp(App);

if (ENV_NAME === 'prod') {
    Sentry.init({
        app,
        dsn: SENTRY_DSN,
        sendDefaultPii: true,
        integrations: [
            Sentry.browserTracingIntegration({ router }),
        ],
        ignoreErrors:[
            "Non-Error exception captured",
            "Non-Error promise rejection captured"
        ]
    });
}

app.use(PrimeVue, {
    // NOTE see autoimport of components: https://primevue.org/autoimport/
    theme: {
        preset: Aura,
        options: {
            cssLayer: {
                name: 'primevue',
                order: 'tailwind-base, primevue, tailwind-utilities'
            },
            // https://primevue.org/theming/styled/#darkmode
            // Note this class (dark-mode) is not implemented
            darkModeSelector: '.dark-mode',
        }
    }
 });

app.use(AmplifyVue);
app.use(createPinia());
app.use(router);
app.use(ConfirmationService);
app.use(ToastService);

app.directive('ripple', Ripple);
app.directive("tooltip", Tooltip);

app.mount('#app');
